import { initializeApp } from 'firebase/app';
// The app only ever does one-off reads (getDocs/getDoc for blog content),
// never onSnapshot/realtime listeners, so the "lite" build is a drop-in
// replacement that strips out Firestore's realtime WebChannel transport
// layer (~35 KiB of otherwise-unused JS flagged by Lighthouse).
import { getFirestore } from 'firebase/firestore/lite';

const firebaseConfig = {
  apiKey: 'AIzaSyAsJ1VFPWHZb5j6jlXCayMFzTMh6KO4-bc',
  authDomain: 'avagyanlaw-19471.firebaseapp.com',
  projectId: 'avagyanlaw-19471',
  storageBucket: 'avagyanlaw-19471.firebasestorage.app',
  messagingSenderId: '1058354457716',
  appId: '1:1058354457716:web:9a9e07b1e37455174b7521',
  measurementId: 'G-N3M05DMF3V',
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
